import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { identity, has, cond, T, always } from 'ramda';

import { validate, formatDate } from 'lib/dateDisplay';
import EditLog from 'components/EditLog';

import transformCommitsIntoEdits from './transformCommitsIntoEdits';

const makeOptMessageHandler = (accessor, formatMessage, messages) => msg =>
  cond([
    [always(validate(msg)), always(formatDate(msg))],
    [has(accessor(msg)), x => formatMessage({ id: accessor(msg) })],
    [has(`dictionary.${msg}`), x => formatMessage({ id: `dictionary.${msg}` })],
    [has(msg), x => formatMessage({ id: msg })],
    [T, always(msg)],
  ])(messages);

const EditLogContainer = ({
  form,
  labelAccessor = identity,
  optionAccessor = identity,
  intl: { formatMessage, messages },
}) => {
  if (form && Array.isArray(form.commits)) {
    return (
      <EditLog
        edits={transformCommitsIntoEdits(form.commits)}
        labelMessage={x => formatMessage({ id: labelAccessor(x || '') })}
        optionMessage={makeOptMessageHandler(optionAccessor, formatMessage, messages)}
        localeMessage={x => formatMessage({ id: x || '' })}
      />
    );
  }
  return null;
};

EditLogContainer.propTypes = {
  form: PropTypes.object,
  labelAccessor: PropTypes.func,
  optionAccessor: PropTypes.func,
  intl: intlShape,
};

export default injectIntl(EditLogContainer);
